import React, { useRef, useState } from "react";

import AsyncSelect from "react-select/async";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import DatePickerInput from "../../../controls/DatePickerInput";
import InputWithSearch from "../../../controls/InputWithSearch";
import ButtonSpinner from "../../../controls/ButtonSpinner";
import PrintConfirmationModal from "../PrintConfirmationModal";

export default function NewPackageDetails1(props) {
  const {
    employeeOptions,
    errors,
    isEdit,
    onSearchLotNumbers,
    handleInputChange,
    packagedProduct,
    values,
    openPackagingOptions,
    handleSavePackageAndPrint,
    showNumberPad,
    setShowNumberPad,
    showBrands,
    scaleIsOpen,
    setScaleIsOpen,
    showErrorModal,
    printInProgress,
    supervisorOptions,
    onLotNumberSelected,
    setEmptyModelOpen,
  } = props;

  const searchRef = useRef();

  const asyncRef = useRef(null);
  const [asyncSelectValue, setAsyncSelectValue] = useState({
    value: -1,
    label: "",
  });

  const loadOptions = async function (input, callback) {
    if (input.length > 2) {
      const result = await onSearchLotNumbers(input);
      callback(result);
    }
  };

  const canPrint = () => {
    if (values.is_free_weight && !(values.packing_size > 0)) {
      showErrorModal("Case weight cannot be 0kg for this product");
      return false;
    }
    return true;
  }; // todo oggy fix

  const tryPrint = (extraPayload = {}) => {
    if (canPrint()) {
      handleSavePackageAndPrint(extraPayload);
    }
  };

  const getProductionRunProductForConfirm = () => {
    const selected = asyncSelectValue;
    if (selected?.value != null && selected.value !== -1) {
      return {
        plu: selected.plu ?? values.production_run_plu,
        name:
          selected.product_name ??
          selected.name ??
          values.production_run_product_name,
        lot_number: selected.lot_number ?? values.lot_number,
      };
    }

    return {
      plu: values.production_run_plu,
      name: values.production_run_product_name,
      lot_number: values.lot_number,
    };
  };

  const openPrintConfirm = (isSkid = false) => {
    if (!canPrint()) return;
    const n = Number(values.number_of_label_to_print) || 1;
    const cartons = n === 1 ? "carton" : "cartons";
    const message = isSkid
      ? `Do you want to print a skid label for ${n} ${cartons}?`
      : `Do you want to print ${n} ${cartons}?`;
    setEmptyModelOpen({
      open: true,
      childComponent: (
        <PrintConfirmationModal
          message={message}
          productionRunProduct={getProductionRunProductForConfirm()}
          packagingProduct={{
            plu: values.plu,
            name: values.product_name,
          }}
          variant={isSkid ? "skid" : "default"}
          setOpen={setEmptyModelOpen}
          onConfirm={() => tryPrint({ is_create_pallet: isSkid })}
        />
      ),
    });
  };

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="col-span-2">
          <AsyncSelect
            cacheOptions
            loadOptions={loadOptions}
            options={[]}
            className="w-full"
            ref={asyncRef}
            onChange={(e) => {
              setAsyncSelectValue(e ?? { value: -1, label: "" });
              onLotNumberSelected(e);
            }}
            value={asyncSelectValue}
          />
        </div>
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="supervisor"
            options={supervisorOptions}
            defaultValue={isEdit ? packagedProduct.supervisor : null}
            title={"Supervisor"}
            value={values.supervisor}
            error={errors.supervisor}
          />
        </div>
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="employee_1"
            options={employeeOptions}
            value={values.employee_1}
            title={"Employee 1"}
            isMulti={true}
          />
        </div>
        <div className="col-span-2">
          <InputWithSearch
            label="Packaging Material 1"
            name="packaging_material_1"
            onChange={handleInputChange}
            actionCall={() => openPackagingOptions("packaging_material_1")}
            ref={searchRef}
            value={values.packaging_material_1}
            labelOn={true}
            type="text"
            error={errors.packaging_material_1}
          />
        </div>
        <div className="col-span-2">
          <InputWithSearch
            label="Packaging Material 2"
            name="packaging_material_2"
            onChange={handleInputChange}
            actionCall={() => openPackagingOptions("packaging_material_2")}
            ref={searchRef}
            value={values.packaging_material_2}
            labelOn={true}
            type="text"
          />
        </div>
        <div className="col-span-2">
          <InputWithSearch
            label="Packaging Material 3"
            name="packaging_material_3"
            onChange={handleInputChange}
            actionCall={() => openPackagingOptions("packaging_material_3")}
            ref={searchRef}
            value={values.packaging_material_3}
            labelOn={true}
            type="text"
          />
        </div>
        <div className="col-span-2">
          <DatePickerInput
            label="Packaging date"
            name="packaging_date"
            onChange={handleInputChange}
            value={values.packaging_date ? values.packaging_date : new Date()}
            labelOn={true}
            // minDate={new Date()}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.packaging_date}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Room Temp C&deg;"
            name="room_temperature"
            onChange={handleInputChange}
            onClick={() => {
              setShowNumberPad({
                show: true,
                name: "room_temperature",
                onChange: handleInputChange,
                value: values.room_temperature,
                showNumberPad: showNumberPad,
                setShowNumberPad: setShowNumberPad,
              });
            }}
            value={values.room_temperature}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.room_temperature}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Product Temp C&deg;"
            name="product_temperature"
            onChange={handleInputChange}
            onClick={() => {
              setShowNumberPad({
                show: true,
                name: "product_temperature",
                onChange: handleInputChange,
                value: values.product_temperature,
                showNumberPad: showNumberPad,
                setShowNumberPad: setShowNumberPad,
              });
            }}
            value={values.product_temperature}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.product_temperature}
          />
        </div>
        <div className="col-span-2">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            <button
              type="button"
              className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600  align-middle h-16"
              onClick={showBrands}
            >
              Brand
            </button>
            <button
              type="button"
              className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 h-16"
              onClick={() => {
                setScaleIsOpen(!scaleIsOpen);
              }}
            >
              Scale
            </button>
            <button
              type="button"
              className="rounded-md bg-gray-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 h-16"
              onClick={() => openPrintConfirm(true)}
              disabled={printInProgress}
            >
              <ButtonSpinner spin={printInProgress} text="Skid label" />
            </button>
            <div className="flex flex-col items-center">
              <button
                type="button"
                className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 h-16 w-full"
                onClick={() => openPrintConfirm(false)}
                disabled={printInProgress}
              >
                <ButtonSpinner spin={printInProgress} text="Print" />
              </button>
              <div className="mt-1 text-xs text-gray-600">RTE Printer</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
